import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController, IonInfiniteScroll, Platform } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { WebParameterContext } from 'src/model/common';
import { GridBaseCase } from 'src/app/components/grid/grid.base.case';
import { QrcodeGroupPage } from '../../qrcode-group/qrcode-group.page'
import { SearchModalPage } from "../search-modal/search-modal.page";
declare var app;
@Component({
  selector: 'app-content-library-list',
  templateUrl: './content-library-list.component.html',
  styleUrls: ['./content-library-list.component.scss']
})
export class ContentLibraryListComponent extends GridBaseCase {
  tabsIndex: any = 0;
  remarkvalue: any; //信息反馈字段
  outOrInType: string;//调出或者调入类型type
  outOrInName: string;
  pageName: string = null;
  searchValue: any = "";
  searchValuedetail: any;// 首页搜索跳过来的搜索关键字参数
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  dataArrayListtop: Array<any> = [];//置顶的数据
  dataArrayListtopCout:number=0;//默认总页数
  articeSelectText: any = "全部";
  articeSelectNum:any = 0;
  listtype: any; // 类型
  articeType: any = "";
  levelThereID:any;//父级Id
  searchName:any;//内容库名称
  articeTypeList: any = [
    { id: "1", name: "全部" },
    { id: "2", name: "活动类" },
    { id: "3", name: "孕妈" },
    { id: "4", name: "宝妈" }
  ];//筛选类型数据源
  sortSelectText: any = "排序方式";
  sortType: any = "1";
  sortTypeList: any = [
    { a_Code: "1", a_Name: "按发布时间排序" },
    { a_Code: "2", a_Name: "按阅读量排序" }
  ];//排序数据源
  allType: string = "";//全部类别
  orderByName: string = "";//排序name
  // 首页搜索
  a_ID: any;
  isLoadAllData: boolean = false;//数据是否加载完成
  clickLoadMoreData: boolean = false;//点击加载更多数据
  articleListData = [];//文章列表数据源
  isFirstLoad: boolean = true;
  closeshow:boolean = true;
  fiCationID:any=""; // 分类id
  a_cID:any=""; //一级标签id
  a_dID:any = ""; // 二级标签id
  a_eID:any = ""; // 三级标签id
  fistylID:any = "";
  istrue:boolean=true;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
    private route: ActivatedRoute,
  ) {
    super();
    this.loadAllTypeList();
    // this.activaRouter.queryParams.subscribe(queryParams => {
    //   console.log(queryParams, "获取的参数集合");
    //   this.listtype = queryParams.type; // 类型 1：首页搜索列表 2：我的收藏 3：浏览历史
    // });
    this.listtype = this.route.snapshot.queryParamMap.get("type");
    this.a_ID = this.route.snapshot.queryParamMap.get("a_ID");// 获取id
    this.searchValuedetail = this.route.snapshot.queryParamMap.get("searchValue");// 获取id
    this.a_cID = this.route.snapshot.queryParamMap.get("a_cID");// 获取id
    this.a_dID = this.route.snapshot.queryParamMap.get("a_dID");// 获取id
    this.a_eID = this.route.snapshot.queryParamMap.get("a_eID");// 获取id
    if (this.listtype == 2) {
      this.baseService.pageTitle = "我的收藏";

      this.sortTypeList = [
        { a_Code: "1", a_Name: "按最新收藏时间排序" },
        { a_Code: "2", a_Name: "按阅读量排序" }
      ];//排
    } else if (this.listtype == 3) {
      this.baseService.pageTitle = "浏览历史";
      this.sortTypeList = [
        { a_Code: "1", a_Name: "按最新浏览时间排序" },
        { a_Code: "2", a_Name: "按阅读量排序" }
      ];//排
    }
    else if(this.listtype == 1 || this.listtype == "1" ){
      if(this.searchValuedetail){
        this.searchValue =this.searchValuedetail;
        this.searchValuedetail="";
      }
      
    }else if(this.listtype == 6 || this.listtype == "6"){
      this.levelThereID=this.route.snapshot.queryParamMap.get("LevelThereID");
      if(this.searchValuedetail){
        this.searchValue =this.searchValuedetail;
        this.searchValuedetail="";
      }
    }
    else if(this.listtype == 8 || this.listtype == "8"){
    
      if(this.searchValuedetail){
        this.searchValue =this.searchValuedetail;
        this.searchValuedetail="";
      }
    }
    // if(this.listtype!=="2" || this.listtype!==2 || this.listtype!=="3"|| this.listtype!==3){
    //   this.LoadDataList();
    // }
    if(this.listtype=="1" || this.listtype ==1 || this.listtype =="6"|| this.listtype==6|| this.listtype=="8" || this.listtype ==8 ){
      this.LoadDataList();
    }
  
    if(!this.searchValue){
      this.closeshow = false;
    }
    // this.searchEvent()
  }

  loadMoreData(event) {
    let that = this;

    if (that.RecordCount == that.dataArrayList.length) {
      that.isLoadAllData = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
      that.clickLoadMoreData = true;
    }
  }
  

  LoadData(PageNumber) {
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    let typeObj = {};
    body.Account = that.com.GetAccount;
    if (that.listtype == 1 || that.listtype == "1" ) {
      body.ConfigName = "V_TBArticleContentXML";
      if (that.sortSelectText == "排序方式") {
        body.QueryOrderBy = [
          {
            "OrderByColumnName": "a_type",
            "OrderByType": "desc"
          },
          {
            "OrderByColumnName": "a_ArticleTime",
            "OrderByType": "desc"
          }
        ];
      } else {
        let ordesc:any= {
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        };
        body.QueryOrderBy=[];
        body.QueryOrderBy.push({
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        });
        if(that.sortSelectText=="按发布时间排序"){
          ordesc.OrderByColumnName="a_ArticleTime";
        }else if(that.sortSelectText=="按阅读量排序"){
          ordesc.OrderByColumnName="a_ReadQuantity";
        }
        body.QueryOrderBy.push(ordesc);
      }

        let _objarr: any = {
          "Value": that.searchValue,
          "LikeType": "Middle",
          "Type": "Like"
        }
        typeObj["a_MergeTitle"] = _objarr;
      
      // if (that.a_ID) {
      //   typeObj["a_FK_TBHighFrequencyTag_ID"] = that.a_ID;
        
      // }
      if (that.allType) {
        typeObj["a_cID"] = that.allType;
      }
      typeObj["a_type"] = 1;
      // typeObj["a_type"] = "2";
      // 一级id
      if(that.a_cID){
        typeObj["a_cID"] = that.a_cID;
      }
      // 二级id
      if(that.a_dID){
        typeObj["a_dID"] = that.a_dID;
      }
      // 三级id
      if(that.a_eID){
        typeObj["a_eID"] = that.a_eID;
      }
      

    } else if(that.listtype == 6 || that.listtype == "6"){
      body.ConfigName = "V_TBArticleContentXML";
      if (that.sortSelectText == "排序方式") {
        body.QueryOrderBy = [
          {
            "OrderByColumnName": "a_type",
            "OrderByType": "desc"
          },
          {
            "OrderByColumnName": "a_ArticleTime",
            "OrderByType": "desc"
          }
        ];
      } else {
             let ordesc:any= {
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        };
        body.QueryOrderBy=[];
        body.QueryOrderBy.push({
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        });
        if(that.sortSelectText=="按发布时间排序"){
          ordesc.OrderByColumnName="a_ArticleTime";
         
          
        }else if(that.sortSelectText=="按阅读量排序"){
          ordesc.OrderByColumnName="a_ReadQuantity";
        }
        body.QueryOrderBy.push(ordesc);
      }
     
      let _objarr: any = {
        "Value": that.searchValue,
        "LikeType": "Middle",
        "Type": "Like"
      }
      // typeObj["a_MergeTitle"] = _objarr;
      if (that.allType) {
        typeObj["a_cID"] = that.allType;
      }
      typeObj["a_type"] = 1;
      if (that.a_ID) {
        typeObj["a_eID"] = that.a_ID;
      }
      
    }
     else if(that.listtype == 8 || that.listtype == "8"){
      body.ConfigName = "V_TBArticleContentXML";
      if (that.sortSelectText == "排序方式") {
        body.QueryOrderBy = [
          {
            "OrderByColumnName": "a_type",
            "OrderByType": "desc"
          },
          {
            "OrderByColumnName": "a_ArticleTime",
            "OrderByType": "desc"
          }
        ];
      } else {
             let ordesc:any= {
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        };
        body.QueryOrderBy=[];
        body.QueryOrderBy.push({
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        });
        if(that.sortSelectText=="按发布时间排序"){
          ordesc.OrderByColumnName="a_ArticleTime";
         
          
        }else if(that.sortSelectText=="按阅读量排序"){
          ordesc.OrderByColumnName="a_ReadQuantity";
        }
        body.QueryOrderBy.push(ordesc);
      }
     
      let _objarr: any = {
        "Value": that.searchValue,
        "LikeType": "Middle",
        "Type": "Like"
      }
      // typeObj["a_MergeTitle"] = _objarr;
      if (that.allType) {
        typeObj["a_cID"] = that.allType;
      }
 
      
      typeObj["a_type"] = 1;
      if (that.a_ID) {
        typeObj["a_eID"] = that.a_ID;
      }
      // 一级id
      if(that.a_cID){
        typeObj["a_cID"] = that.a_cID;
      }
      // 二级id
      if(that.a_dID){
        typeObj["a_dID"] = that.a_dID;
      }
      // 三级id
      if(that.a_eID){
        typeObj["a_eID"] = that.a_eID;
      }
    
    }

    else if (that.listtype == 2 || that.listtype == "2") {
      body.ConfigName = "GetArticleCollection"; // 我的收藏
      body.QueryOrderBy = [
        {
          "OrderByColumnName": "a_ModifyTime",
          "OrderByType": "desc"
        }
      ];
      if (that.sortSelectText == "按阅读量排序") {
        body.QueryOrderBy = [
        
          {
            "OrderByColumnName": "e_ReadQuantity",
            "OrderByType": "desc"
          }
        ];
      } 
      if(that.searchValue){
        typeObj["f_TagName"] = that.com.LikeSearch(that.searchValue);
      }
      if (that.allType) {
        typeObj["d_ID"] = that.allType;
      }
      
      // typeObj["a_type"] = 1;
      if (that.a_ID) {
        typeObj["a_eID"] = that.a_ID;
      }
      if(that.a_cID ||  that.a_dID || that.a_eID){
        typeObj={};
        // 一级id
      if(that.a_cID){
        typeObj["d_ID"] = that.a_cID;
      }
      // 二级id
      if(that.a_dID){
        typeObj["c_ID"] = that.a_dID;
      }
      // 三级id
      if(that.a_eID){
        typeObj["b_ID"] = that.a_eID;
      }
      }
    } else if (that.listtype == "3" || that.listtype == 3) {
      body.ConfigName = "GetArticleSNCHistory"; // 浏览历史
      body.QueryOrderBy = [
         
        {
          "OrderByColumnName": "a_ModifyTime",
          "OrderByType": "desc"
        }
      ];
      if (that.sortSelectText == "按阅读量排序") {
        body.QueryOrderBy = [
         
          {
            "OrderByColumnName": "e_ReadQuantity",
            "OrderByType": "desc"
          }
        ];
      }
     
      if(that.searchValue){
        typeObj["f_TagName"] = that.com.LikeSearch(that.searchValue);
      }
      if (that.allType) {
        typeObj["d_ID"] = that.allType;
      }
      // typeObj["a_type"] = 1;
      if (that.a_ID) {
        typeObj["a_eID"] = that.a_ID;
      }
      if(that.a_cID ||  that.a_dID || that.a_eID){
        typeObj={};
        // 一级id
      if(that.a_cID){
        typeObj["d_ID"] = that.a_cID;
      }
      // 二级id
      if(that.a_dID){
        typeObj["c_ID"] = that.a_dID;
      }
      // 三级id
      if(that.a_eID){
        typeObj["b_ID"] = that.a_eID;
      }
      }
      
      // typeObj["d_Name"]=that.com.LikeSearch(that.allType);
    }

    // else if()

    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
      
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.isFirstLoad = false;
      that.clickLoadMoreData = false;
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        // that.baseService.arrayData = [];
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
      /****判断是否第一页end****/
     
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(item =>{
          if(item.e_ArticleTime){
            item.e_ArticleTime=item.e_ArticleTime.replace(/-/g,"/").replace("T","");
          }
          if(item.a_ArticleTime){
            item.a_ArticleTime=item.a_ArticleTime.replace(/-/g,"/").replace("T","");
          }
          if(item.a_ModifyTime){
            item.a_ModifyTime=item.a_ModifyTime.replace(/-/g,"/").replace("T","");
          }
        });
          if(that.listtype == 1 || that.listtype == "1"){
            data.Status.Datas.forEach(item =>{
              if(item.a_type == 1 || item.a_type == "1"){
                if(item.a_ModifyTime){
                  item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
                }
                that.dataArrayList.push(item);
              }
            })
            
          }else if(that.listtype == 6 || that.listtype == "6"){
            data.Status.Datas.forEach(item =>{
              if(item.a_type == 1 || item.a_type == "1"){
                that.dataArrayList.push(item);
                if(item.a_ModifyTime){
                  item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
                }
                if(item.a_ArticleTime){
                  item.a_ArticleTime= item.a_ArticleTime.replace(/-/g,"/").replace("T","");
                }
              }
            })
          }
          else{
            data.Status.Datas.forEach(function (item) {
              that.dataArrayList.push(item);
              if(item.a_ModifyTime){
                item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
              }
            });
          }
        
      
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          that.isLoadAllData = true;
        } else {
          that.isLoadAllData = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.isFirstLoad = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
    });
  }
  LoadDataList() {
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    let typeObj = {};
    body.Account = that.com.GetAccount;
    if (that.listtype == 1 || that.listtype == "1" ) {
      body.ConfigName = "V_TBArticleContentXML";
      if (that.sortSelectText == "排序方式") {
        body.QueryOrderBy = [
          {
            "OrderByColumnName": "a_type",
            "OrderByType": "desc"
          },
          {
            "OrderByColumnName": "a_ArticleTime",
            "OrderByType": "desc"
          }
        ];
      } else {
        let ordesc:any= {
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        };
        body.QueryOrderBy=[];
        body.QueryOrderBy.push({
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        });
        if(that.sortSelectText=="按发布时间排序"){
          ordesc.OrderByColumnName="a_ArticleTime";
        }else if(that.sortSelectText=="按阅读量排序"){
          ordesc.OrderByColumnName="a_ReadQuantity";
        }
        body.QueryOrderBy.push(ordesc);
      }

        let _objarr: any = {
          "Value": that.searchValue,
          "LikeType": "Middle",
          "Type": "Like"
        }
        typeObj["a_MergeTitle"] = _objarr;
        typeObj["a_type"] = 2;
      
      // if (that.a_ID) {
      //   typeObj["a_FK_TBHighFrequencyTag_ID"] = that.a_ID;
        
      // }
      if (that.allType) {
        typeObj["a_cID"] = that.allType;
      }
      // typeObj["a_type"] = "2";

    } else if(that.listtype == 6 || that.listtype == "6"){
      body.ConfigName = "V_TBArticleContentXML";
      if (that.sortSelectText == "排序方式") {
        body.QueryOrderBy = [
          {
            "OrderByColumnName": "a_type",
            "OrderByType": "desc"
          },
          {
            "OrderByColumnName": "a_ArticleTime",
            "OrderByType": "desc"
          }
        ];
      } else {
             let ordesc:any= {
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        };
        body.QueryOrderBy=[];
        body.QueryOrderBy.push({
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        });
        if(that.sortSelectText=="按发布时间排序"){
          ordesc.OrderByColumnName="a_ArticleTime";
         
          
        }else if(that.sortSelectText=="按阅读量排序"){
          ordesc.OrderByColumnName="a_ReadQuantity";
        }
        body.QueryOrderBy.push(ordesc);
      }
     
      let _objarr: any = {
        "Value": that.searchValue,
        "LikeType": "Middle",
        "Type": "Like"
      }
      typeObj["a_MergeTitle"] = _objarr;
      if (that.allType) {
        typeObj["a_cID"] = that.allType;
      }
      typeObj["a_type"] = 2;
    }
    else if(that.listtype == 8 || that.listtype == "8"){
      body.ConfigName = "V_TBArticleContentXML";
      if (that.sortSelectText == "排序方式") {
        body.QueryOrderBy = [
          {
            "OrderByColumnName": "a_type",
            "OrderByType": "desc"
          },
          {
            "OrderByColumnName": "a_ArticleTime",
            "OrderByType": "desc"
          }
        ];
      } else {
             let ordesc:any= {
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        };
        body.QueryOrderBy=[];
        body.QueryOrderBy.push({
          "OrderByColumnName": "a_type",
          "OrderByType": "desc"
        });
        if(that.sortSelectText=="按发布时间排序"){
          ordesc.OrderByColumnName="a_ArticleTime";
         
          
        }else if(that.sortSelectText=="按阅读量排序"){
          ordesc.OrderByColumnName="a_ReadQuantity";
        }
        body.QueryOrderBy.push(ordesc);
      }
     
      let _objarr: any = {
        "Value": that.searchValue,
        "LikeType": "Middle",
        "Type": "Like"
      }
      typeObj["a_MergeTitle"] = _objarr;
      if (that.allType) {
        typeObj["a_cID"] = that.allType;
      }
      typeObj["a_type"] = 2;
      // // 一级id
      // if(that.a_cID){
      //   typeObj["a_cID"] = that.a_cID;
      // }
      // // 二级id
      // if(that.a_dID){
      //   typeObj["a_dID"] = that.a_dID;
      // }
      // // 三级id
      // if(that.a_eID){
      //   typeObj["a_eID"] = that.a_eID;
      // }
      
      // typeObj["a_type"] = 2;
      // if (that.a_ID) {
      //   typeObj["a_eID"] = that.a_ID;
      // }
      
    }

    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
      
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.dataArrayListtop=[];
        that.dataArrayListtopCout=data.Status.Datas.length;
        data.Status.Datas.forEach(item =>{
          if(item.e_ArticleTime){
            item.e_ArticleTime=item.e_ArticleTime.replace(/-/g,"/").replace("T","");
          }
          if(item.a_ArticleTime){
            item.a_ArticleTime=item.a_ArticleTime.replace(/-/g,"/").replace("T","");
          }
          if(item.a_ModifyTime){
            item.a_ModifyTime=item.a_ModifyTime.replace(/-/g,"/").replace("T","");
          }
            if (item.a_AppletIcon) {
              item.a_AppletIcon = (app.FileUoloadUrl + item.a_AppletIcon).replace(app.ImagePlaceholder,app.SmallImageType);
            }
          if (item.a_AppletSunCode) {
            item.a_AppletSunCode = (app.FileUoloadUrl + item.a_AppletSunCode).replace(app.ImagePlaceholder,app.BigImageType);
          }
          that.dataArrayListtop.push(item);
        });
      }

    }).catch(error => {
    });
  }


  // searchEvent(e, type: string = 'type') {

  //   const that = this;
   
    
  //   if (e.keyCode == 13 || type == 'search') {
  //     that.LoadData(1);
  //     that.loadAllTypeList();
  //   }
  // }
  async searchEventEve(){
    const that = this;
    if(that.istrue){
      const modal = await this.modal.create({
        component: SearchModalPage,
        componentProps: {
          "Type": "List",
        }
      });
      await modal.present();
      const { data } = await modal.onWillDismiss();
    }

  }

  async searchEvent() {
    const that = this;
    that.istrue=false;
      let url:Array<string>=new Array<string>();
      url.push("/tabs/contact/HomeSFA/add/20200628175213");
      localStorage.setItem("backurl",JSON.stringify(url));
      that.com.Go("/tabs/contact/ContentLibraryHome/" + this.com.getNowDatetime);
  }
  async openSearchModel() {
    // this.isShowSearchModel = true;
    // this.com.setHistoryUrl();
   
  }


  /**
 * 排序类型改变
 */
  sortChangeSelect(e) {
    let that = this;
    that.sortType = e.target.value;
    that.sortTypeList.forEach((item) => {
      if (item["a_Code"] == that.sortType) {
        that.sortSelectText = item["a_Name"];
      }
    })
    that.LoadData(1);
    // if(that.listtype!=="2" || that.listtype!==2 || that.listtype!=="3"|| that.listtype!==3){
    //   that.LoadDataList();
    // }
    if(this.listtype=="1" || this.listtype ==1 || this.listtype =="6"|| this.listtype==6|| this.listtype=="8" || this.listtype ==8 ){
      this.LoadDataList();
    }
  
  }

  /**
* 排序类型改变
* 全部类别改变筛选
*/
articeChangeSelect(e) {
    let that = this;
    that.articeType = e.target.value;
    that.fistylID="";
    that.articeTypeList.forEach((item) => {
      if (item["id"] == that.articeType) {
        that.articeSelectText = item["name"];
        that.articeSelectNum = item["Count"] || 0;
      }
    })
    that.allType = e.target.value;
    that.fistylID = that.allType;
    if(that.listtype==2 || that.listtype=="2" || that.listtype==3|| that.listtype=="3"){
      that.a_cID=e.target.value;
    }
    that.LoadData(1);
    // if(that.listtype!="2" || that.listtype!=2 || that.listtype!="3"|| that.listtype!=3){
    //   that.LoadDataList();
    // }
    if(this.listtype=="1" || this.listtype ==1 || this.listtype =="6"|| this.listtype==6|| this.listtype=="8" || this.listtype ==8 ){
      this.LoadDataList();
    }
  
    // that.LoadDataList();
  }
  //  点击二维码弹窗
  async qcordDetail(item) {
    console.log("点击弹窗")
    const that = this;
    const modal = await that.modal.create({
      component: QrcodeGroupPage,
      componentProps: {
        "url": item.a_AppletSunCode,
        "name": item.a_Title
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data, "onWillDismiss");
  }

  /**
   * 
   * @param e 跳转页面
   */
  EvrntDetail(item, i) {
    const that = this;
    let a_ID: any;
    if (that.listtype == 1 || that.listtype == "1" ) {
      a_ID = item.a_ID;
    }
    if(that.listtype == 6 || that.listtype == "6"){
      a_ID = item.a_ID;
    }
    if (that.listtype == 2 || that.listtype == "2") {
      a_ID = item.e_ID;
    }
    if (that.listtype == 3 || that.listtype == "3") {
      a_ID = item.e_ID;
    }
    if (that.listtype == 8 || that.listtype == "8") {
      a_ID = item.a_ID;
    }
    that.com.setHistoryUrl(false);
    that.com.Go("/tabs/contact/ContentLibraryDetail/" + this.com.getNowDatetime,{
      a_ID: a_ID,
      type: that.listtype, // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    })
   
  }
   // 标签跳转
   classifiCation(item,id,num){
    const that =this;
    // that.com.setHistoryUrl(false);
    that.searchValue=item;
    this.closeshow = true;
    let a_cID:any ="";
    let a_dID:any ="";
    let a_eID:any ="";
    switch(num){
      case 1:
        a_cID= id;
        break;
      case 2:
        a_dID = id;
        break;
      case 3:
        a_eID= id;
        break;
    }
    that.a_cID = a_cID;
    that.a_dID = a_dID;
    that.a_eID = a_eID;
    if(that.a_cID || that.a_dID || that.a_eID){
      that.fistylID= that.a_cID || that.a_dID || that.a_eID;
    }
     that.loadAllTypeList();
    that.LoadData(1);
    // if(that.listtype!=="2" || that.listtype!==2 || that.listtype!=="3"|| that.listtype!==3){
    //   that.LoadDataList();
    // }
    // debugger;
    if(this.listtype=="1" || this.listtype ==1 || this.listtype =="6"|| this.listtype==6|| this.listtype=="8" || this.listtype ==8 ){
      this.LoadDataList();
    }
  
    // that.router.navigate(["/tabs/contact/ContentLibraryDetails/" + this.com.getNowDatetime], {
    //   queryParams: {
    //     nodeLevel:nodeLevel,
    //     fiCationID: id, //分类标签id
    //     fiCaName:name, // 分类名称
    //   }
    // });
  }

  /**
   * 加载全部类型数据
   */  
  loadAllTypeList() {
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    let typeObj = {};
    body.Account = that.com.GetAccount;
    body.ConfigName = "GetBrowseHistoryType"; //全部类型
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 1000;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;

    // body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.loadAllTypeListNum();//加载类型数量
        // that.articeTypeList = [];
        // that.articeTypeList.push({ "id": "", "name": "全部" ,"Count":0 });
        // data.Status.forEach(item => {
        //   that.articeTypeList.push(item);
        // })
        // console.log(that.articeTypeList, "dataArrayList");
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

    /**
   * 加载全部类型的数量
   */
  loadAllTypeListNum() {
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    let typeObj = {};
    body.Account = that.com.GetAccount;
    body.ConfigName = "CategoriesPrimaryCount"; //全部类型
    body.OpType = "query";
    body.ConfigType = "form";
    body.RowsPerPage = 1000;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if(that.listtype == 1  || that.listtype == "1"){
      let _obj = {};
      if(that.searchValue){
        _obj["Name"] = that.searchValue;
      }
      // if(that.fistylID){
      //   let _obj = {};
      //   _obj["ID"] = that.fistylID;
      // }
      // if(that.a_ID){
      //   _obj["ID"] = that.a_ID;
      // }
      body.RequestBody = JSON.stringify(_obj);
    }else if(that.listtype == 6 ||that.listtype == "6" ){
      let _obj = {};
      if(that.a_ID){
        _obj["ID"] = that.a_ID;
      }
      body.RequestBody = JSON.stringify(_obj);
    }else if(that.listtype == 8 ||that.listtype == "8" ){
    
      that.fistylID= that.a_cID || that.a_dID || that.a_eID;
      if(that.fistylID){
        let _obj = {};
        _obj["ID"] =  that.fistylID;
        body.RequestBody = JSON.stringify(_obj);
      }
     
    }
   
    else if(that.listtype == 2 || that.listtype == "2"){
      body.ConfigName = "GetArticleCollectionCount";
      if(that.searchValue){
        body.RequestBody = JSON.stringify({
          tagName:that.searchValue
        });
      }
    }else if(that.listtype == 3 || that.listtype == "3" ){
      body.ConfigName = "GetBrowseHistoryType";
      if(that.searchValue){
        body.RequestBody = JSON.stringify({
          tagName:that.searchValue
        });
      }
    } 
     if(that.listtype == 8 ||that.listtype == "8" ||  that.listtype == 2 ||that.listtype == "2" ||  that.listtype == 3 || that.listtype == "3"  ||  that.listtype == 1 || that.listtype == "1"){
     
      if(that.fistylID){
        let _obj = {};
        _obj["ID"] = that.fistylID;
        body.RequestBody = JSON.stringify(_obj);
      }
    }
   
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页end****/
      // console.log(data,"--------------------------------------------------------");
      if (data.ResponseMessage.Success) {
        let statusNum = {};
        let allNum = 0;
        if(that.listtype == 1 ){
          if(data.Status.Datas.length > 0){
            that.articeTypeList= [];
            data.Status.Datas.forEach(item => {
              allNum+=(item["Count"] || 0);
              item["Count"] = item["Count"];
              item["id"] = item["id"] || "";
              that.articeTypeList.push(item);
            });
            that.articeTypeList.unshift({
              "id":"",
              "name": "全部" ,
              "Count": allNum
            });
            that.articeSelectNum = allNum;
          }
          return;
        }else if( that.listtype == 6 || that.listtype == '6'){
          if(data.Status.Datas.length > 0){
            that.articeTypeList= [];
            data.Status.Datas.forEach(item => {
              allNum+=(item["Count"] || 0);
              item["Count"] = item["Count"];
              item["id"] = item["id"] || "";
              that.articeTypeList.push(item);
            });
            that.articeTypeList.unshift({
              "id":"",
              "name": "全部" ,
              "Count": allNum
            });
            that.articeSelectNum = allNum;
          }
          return;
        }
        else if( that.listtype == 8 || that.listtype == '8'){
          if(data.Status.Datas.length > 0){
            that.articeTypeList= [];
            data.Status.Datas.forEach(item => {
              allNum+=(item["Count"] || 0);
              item["Count"] = item["Count"];
              item["id"] = item["id"] || "";
              that.articeTypeList.push(item);
            });
            that.articeTypeList.unshift({
              "id":"",
              "name": "全部" ,
              "Count": allNum
            });
            that.articeSelectNum = allNum;
          }
          return;
        }
        else if(that.listtype == 2 || that.listtype == "2"){
          // if(data.Status.Datas.length > 0){
          //   statusNum = data.Status.Datas[0];
          //   allNum = (statusNum["ActiveNum"] || 0) + (statusNum["BaoNum"] || 0) + (statusNum["YunNum"] || 0); 
          //   that.articeSelectNum = allNum;
          // }
          // that.articeTypeList.forEach(item => {
          //   if(item["name"] == "全部"){
          //     item["Count"] = allNum;
          //   }else if(item["name"] == "宝妈必看"){
          //     item["Count"] = statusNum["BaoNum"] || 0;
          //   }else if(item["name"] == "孕妈必看"){
          //     item["Count"] = statusNum["YunNum"] || 0;
          //   }else if(item["name"] == "会员活动"){
          //     item["Count"] = statusNum["ActiveNum"] || 0;
          //   }
          // });
          if(data.Status.length > 0){
            that.articeTypeList = [];
            data.Status.forEach(item => {
              allNum+=(item["Count"] || 0);
              that.articeTypeList.push(item);
            });
            that.articeTypeList.unshift({
              "id":"",
              "name": "全部" ,
              "Count": allNum
            });
            that.articeSelectNum = allNum;
          }
        }else if(that.listtype == 3 || that.listtype == "3"){
          if(data.Status.length > 0){
            that.articeTypeList = [];
            data.Status.forEach(item => {
              allNum+=(item["Count"] || 0);
              that.articeTypeList.push(item);
            });
            that.articeTypeList.unshift({
              "id":"",
              "name": "全部" ,
              "Count": allNum
            });
            that.articeSelectNum = allNum;
          }
        }
        that.articeTypeList.forEach((item) => {
          if (item["id"] == that.articeType) {
            that.articeSelectText = item["name"];
            that.articeSelectNum = item["Count"] || 0;
          }
        })
        
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

}
 